import {
  AddressingType,
  BuildingDTO,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'BuildingItem',
  props: {
    building: {
      type: BuildingDTO,
      required: true,
    },
    plantAddressType: {
      type: Number,
      required: true,
    },
  },
  emits: ['building-selected'],
})
export default class BuildingItem extends Vue {
  building!: BuildingDTO;
  plantAddressType!: AddressingType;

  get risersFloorApartmentCount() {
    let risersCount = '';
    let floorsCount = '';
    let apartmentsCount = '';

    if (this.plantAddressType === AddressingType.BuildingRiserFloorApartment) {
      risersCount = `${this.building.risers?.length} ${this.$t(
        'AppResourceEP.Risers'
      )}`;
      floorsCount = `${this.building.floors?.length} ${this.$t(
        'AppResourceEP.Floors'
      )}`;
    }

    apartmentsCount = `${this.building.apartments?.length} ${this.$t(
      'AppResourceEP.Apartments'
    )}`;

    return `${risersCount} ${floorsCount} ${apartmentsCount}`;
  }
}
